<template>
  <div>
    <div class="row" style="margin-bottom: 80px">
      <div class="col-lg-2"></div>
      <div class="col-lg-8 text-center">
        <h5 class="ma-28-semi text-green text-uppercase m-0">
          {{ $t("guideline-title-1") }}
        </h5>
        <span class="in-16-re">
          {{ $t("guideline-description-1") }}
        </span>
      </div>
      <div class="col-lg-2"></div>
    </div>
    <div class="container-fluid">
      <div v-if="top3Posts" class="row">
        <div v-for="item, index in top3Posts" :key="index" class="col-lg-4 col-md-6 pb-5">
          <div class="content-card" @click="handleClick(item.Link)">
            <div class="img-container">
              <img :src="item.Avatar" height="256px" />
            </div>
            <h4 class="m-3 ma-24-semi text-green">{{ item.Title }}</h4>
            <div class="px-3">
              <div class="separator"></div>
            </div>
            <p class="m-24">
              {{ item.ShortContent }}
            </p>
          </div>
        </div>
       
      </div>
    </div>
    <div>
      <div class="row" style="margin-bottom: 80px; margin-top: 72px">
        <div class="col-lg-2 col-md-1"></div>
        <div class="col-lg-8 col-md-9 text-center">
          <h5 class="ma-28-semi text-green m-0">
            {{ $t("guideline-title-2") }}
          </h5>
          <span class="in-16-re">
            {{ $t("guideline-description-2") }}
          </span>
        </div>
        <div class="col-lg-2 col-md-1"></div>
      </div>
      <div class="container-fluid">
       
        <div v-if="popularPost" class="row">
          <div v-for="item, index in popularPost" :key="index" class="col-lg-4 col-md-6 pb-5">
            <div class="content-card" @click="handleClick(item.Link)">
              <div class="img-container">
                <img :src="item.Avatar" height="256px" />
              </div>
              <h4 class="m-3 ma-24-semi text-green">{{ item.Title }}</h4>
              <div class="px-3">
                <div class="separator"></div>
              </div>
              <p class="m-24">
                {{ item.ShortContent }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      postData: null,
      // blogList: [
      //   {
      //     img: "/assets/image/bg/bg_19.png",
      //     title: this.$t("overview"),
      //     link: "overview",
      //     content: this.$t("overview-content"),
      //   },
      //   {
      //     img: "/assets/image/bg/bg_22.png",
      //     title: this.$t("app"),
      //     link: "app",
      //     content: this.$t("app-content"),
      //   },
      //   {
      //     img: "/assets/image/bg/img_7.png",
      //     title: this.$t("manual-guide"),
      //     link: "manual",
      //     content: this.$t("feature-info-content"),
      //   },
      //   {
      //     img: "/assets/image/bg/bg_22.png",
      //     title: this.$t("feature-info2"),
      //     link: "featureplanning",
      //     content: this.$t("feature-info2-content"),
      //   },
      //   {
      //     img: "/assets/image/bg/bg_21.png",
      //     title: this.$t("feature-info3"),
      //     link: "blog",
      //     content: this.$t("feature-info3-content"),
      //   },
      //   {
      //     img: "/assets/image/bg/bg_19.png",
      //     title: this.$t("mean"),
      //     link: "blog2",
      //     content: this.$t("mean-content"),
      //   },
       
      // ],
    };
  },
 



  computed:{
    ...mapGetters(["getPostData"]),

    top3Posts(){
      //each posttypecode select 1, max is 3 
      if(!this.getPostData) return []
      let sorteData = this.getPostData;
      let res = []
      sorteData.forEach(item => {
        if(!res.find(_item=>_item.PostTypeCode == item.PostTypeCode)){
          res.push(item)
        }
      });
      return res.sort((a,b)=>a.Sort - b.Sort).slice(0,3)
        
    }, 
    popularPost(){
      if(!this.getPostData) return []
      let sorteData = this.getPostData;
      return sorteData.sort((a,b)=>a.Sort - b.Sort)
    }
  },
  methods: {
    handleClick(route) {
      this.$router.push( { path: '/guideline/detail', query: { post: route } }).catch(error=>{});
     
    },
   
  },
};
</script>

<style scoped>
.content-card:hover {
  border: 1px solid var(--hover, #063);
}
.content-card:hover .img-container img {
  transform: scale(1.1); /* Phóng to lên 110% */
}
.img-container {
  display: inline-block; /* hoặc block tùy vào cấu trúc của bạn */
  overflow: hidden;
}

.img-container img {
  transition: transform 0.5s ease; /* Tạo hiệu ứng mềm mại */
}

.img-container:hover img {
  transform: scale(1.1); /* Phóng to lên 110% */
}
.separator {
  width: 100%;
  height: 1px;
  background-color: #eaecea;
}
.m-24 {
  margin: 24px;
}
.font-64 {
  font-size: 64px;
}
.font-24 {
  font-size: 24px;
}
.title-block {
  font-size: 12px;
  font-weight: 300;
  color: #636466;
  width: 75%;
}
.title-secondary {
  font-size: 16px;
  font-weight: 300;
  color: #636466;
  width: 75%;
  margin-bottom: 40px !important;
}
.content-slogan {
  color: #c71313;
  font-size: 48px !important;
  width: 50%;
  margin: 16px 0 !important;
}
.content-card {
  border: 1px solid #e6e8ec;
  /* border-radius: 24px; */
  overflow: hidden;
  transition: 500ms;
  cursor: pointer;
  /* height: 477px; */
}
.content-card h4 {
  font-size: 24px !important;
  font-weight: 500;
}
.content-card p {
  max-height: 200px !important;
  text-overflow: ellipsis;
  overflow: hidden !important;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Số dòng tối đa */
  -webkit-box-orient: vertical;
}
</style>
